import { createFileRoute } from '@tanstack/react-router'
import Component from './-components/component'

export const Route = createFileRoute('/technician/_layout/expiry-track/')({
  component: Component,
})